import { Link } from 'react-router-dom';

export default function AddOnsSection() {
  const shots = [
    {
      name: 'Vitamin B12 Shot',
      volume: '1 mL',
      price: '$25',
      description: 'A quick energy boost that supports nerve function, red blood cell production, and mental clarity.',
      icon: 'ri-flashlight-line',
    },
    {
      name: 'Vitamin B Complex Shot',
      volume: '1 mL',
      price: '$25',
      description: 'Includes five essential B Vitamins (B1, B2, B3, B5, B6) to create energy, boost metabolism, burn fat, and revitalize your immune system at the cellular level.',
      icon: 'ri-capsule-line',
    },
  ];

  const addOns = [
    'Vitamin C Boost',
    'Glutathione',
    'B12 Shot',
    'Biotin',
    'Magnesium',
    'Zinc',
    'Amino Acids',
    'Taurine',
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-bone">
      <div className="max-w-7xl mx-auto">

        {/* Vitamin Shots */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 bg-gold/20 text-gold text-xs tracking-widest uppercase rounded-full mb-4">
              Quick Shots
            </span>
            <h3 className="text-4xl font-light text-charcoal mb-3 tracking-wide">
              Vitamin Shots
            </h3>
            <p className="text-greige text-base font-light max-w-xl mx-auto">
              Fast, effective single-dose injections for an instant wellness lift.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {shots.map((shot, index) => (
              <div
                key={index}
                className="bg-sand rounded-2xl p-8 border border-gold/20 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-gold/15 rounded-full mb-5">
                  <i className={`${shot.icon} text-2xl text-gold`}></i>
                </div>
                <div className="flex items-baseline justify-between mb-3">
                  <h4 className="text-xl font-normal text-charcoal tracking-wide">
                    {shot.name}
                  </h4>
                  <span className="text-xs text-greige font-light ml-2 whitespace-nowrap">{shot.volume}</span>
                </div>
                <p className="text-3xl font-light text-gold mb-4">{shot.price}</p>
                <p className="text-greige text-sm font-light leading-relaxed">
                  {shot.description}
                </p>
                <div className="w-0 h-0.5 bg-gold mt-6 group-hover:w-full transition-all duration-500"></div>
              </div>
            ))}
          </div>
        </div>

        {/* IV Add-Ons */}
        <div className="text-center">
          <h3 className="text-3xl font-light text-charcoal mb-4 tracking-wide">
            Customize Your Drip
          </h3>
          <p className="text-greige text-base font-light mb-8 max-w-2xl mx-auto">
            Enhance your treatment with premium add-ons tailored to your wellness goals.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {addOns.map((addOn, index) => (
              <button
                key={index}
                className="px-6 py-3 border-2 border-charcoal text-charcoal text-sm font-light tracking-wide rounded-full hover:bg-charcoal hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                {addOn}
              </button>
            ))}
          </div>

          <Link
            to="/book"
            className="inline-block px-12 py-4 bg-charcoal text-white text-base font-light tracking-wide rounded-full hover:bg-charcoal/90 hover:scale-105 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Your Session
          </Link>
        </div>

      </div>
    </section>
  );
}
